import React from 'react';
import './Faculty.css';
import facultyOne from '../../../assets/Gallery/aboutOne.png';
import facultyTwo from '../../../assets/Gallery/aboutTwo.png';
import facultyThree from '../../../assets/Gallery/aboutThree.png';
import facultyFour from '../../../assets/Gallery/roadmapOne.png';
import facultyFive from '../../../assets/Gallery/roadmapTwo.png';
import facultySix from '../../../assets/Gallery/roadmapThree.png';

function Faculty() {
    return (
        <div className='faculty-outer'>
            <div className="faculty-inner d-flex flex-column">
                <h2 className="header-text">Gallery</h2>
                <div className="faculty-images">
                    <div className="faculty-image">
                        <img src={facultyOne} alt="Faculty 1" />
                    </div>
                    <div className="faculty-image">
                        <img src={facultyTwo} alt="Faculty 2" />
                    </div>
                    <div className="faculty-image">
                        <img src={facultyThree} alt="Faculty 3" />
                    </div>
                    <div className="faculty-image">
                        <img src={facultyFour} alt="Faculty 3" />
                    </div>
                    <div className="faculty-image">
                        <img src={facultyFive} alt="Faculty 3" />
                    </div>
                    <div className="faculty-image">
                        <img src={facultySix} alt="Faculty 3" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Faculty;
